type InitialState<T> = {
  searchCriteria: T
  cacheKey: string | undefined
}

type Choice = 'y' | 'n'

export type UrlParam<T> = {
  path: string
  parameters: {
    referrerPath: string
    initialStates?: InitialState<T>
  },
  isPrint?: Choice,
}

export function encodeUrlQueryParams<T> (
  args: UrlParam<T>
): string {
  const urlParams = JSON.stringify(args)
  return btoa(encodeURIComponent(urlParams))
}

export function decodeUrlQueryParams<T> (
  encodedParams: string
): UrlParam<T> {
  const normalized = encodedParams.replace(/ /g, '+')
  const decodedJson = decodeURIComponent(atob(normalized))
  return JSON.parse(decodedJson)
}
